'use client';

import { ArrowLeftIcon } from 'lucide-react';
import type { Route } from 'next';
import { usePathname, useSearchParams } from 'next/navigation';
import { ButtonLink } from '@/components/ui/button-link';

type TBackButton = {
  ignoreSearchParams?: boolean;
  /** Overrides the derived parent path, e.g. for detail pages with sub routes. */
  path?: Route;
};

function getParentPath(pathname: string) {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length <= 1) return '/';
  return `/${segments.slice(0, -1).join('/')}`;
}

const BackButton = ({ ignoreSearchParams = false, path }: TBackButton) => {
  const pathname = usePathname();
  const searchParams = useSearchParams().toString();
  const previousPath = path ?? getParentPath(pathname);
  const sp = ignoreSearchParams ? '' : searchParams ? `?${searchParams}` : '';

  return (
    <ButtonLink
      href={`${previousPath}${sp}` as Route}
      variant='ghost'
      size='icon'
      className='rounded-full'
    >
      <ArrowLeftIcon
        aria-label='Gå tillbaka'
        size={18}
        strokeWidth={1.5}
        className='pointer-events-none'
      />
    </ButtonLink>
  );
};

export default BackButton;
